import {
  Component,
  OnInit,
  Input,
  OnChanges,
  HostListener,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router, ActivatedRoute } from "@angular/router";
import { NavMenuComponent } from "../nav-menu/nav-menu.component";
import { WriteUsComponent } from "../../components/pop-ups/write-us/write-us.component";
import { CallBackComponent } from "../../components/pop-ups/call-back/call-back.component";
import { LocateUsComponent } from "../../components/pop-ups/locate-us/locate-us.component";
import { CommonDataService } from "../../shared/services/common-data.service";
import { ApiService } from "../../shared/services/api.service";
import { Urls } from "../../utils/urls";
import { HeaderService } from './header.service';
import { response } from "express";
import {environment} from '../../../environments/environment.prod'


@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit, OnChanges {
  @Input() breadCrumbs;
  data: any;

  pageUrl: string;

  headerData = {
    topMenus: [
      {
        displayName: "Products",
        url: "products",
        val: "products",
      },
      {
        displayName: "NAV & IDCW",
        url: "nav-dividends",
        val: "nav-dividends",
      },
      {
        displayName: "Factsheet",
        url: "downloads",
        val: "downloads",
      },
      {
        displayName: "Investors",
        url: "investors",
        val: "investors",
      },
      {
        displayName: "Partners",
        url: "distributor",
        val: "distributor",
      },
      {
        displayName: "CIO's Desk",
        url: "ceo-desk",
        val: "ceo-desk",
      },
    ],
  };

  activeTab = "";

  subscription: any;

  latestNav: any = [];

  banners = [];
  
  subBreadCrumb: any;

  bannerObj : any;

  public isSocialShare = false;
  
  constructor(
    private modalService: NgbModal,
    private router: Router,
    public commonDataService: CommonDataService,
    public apiService: ApiService,
    public activatedRoute: ActivatedRoute,
    private headerService: HeaderService) {

    this.commonDataService.dataSourceSub.asObservable().subscribe((data) => {
      this.subBreadCrumb = data;
    });
  }

  ngOnChanges() {
    this.data = this.breadCrumbs;
    this.pageUrl = this.data.url
    if (
      this.data.url === "products" ||
      this.data.url === "nav-dividends" ||
      this.data.url === "downloads"
    ) {
      this.activeTab = this.data.url;
    } else {
      this.activeTab = "";
    }

    this.setCarousel();
  }

  ngOnInit() {
   this.headerService.isSocialShareChange.subscribe( status => {
      this.isSocialShare = status;
    });
    this.getLatestNav();
  }

  scrollTop = () => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  phoneTo(mobile) {
    window.open(`tel:${mobile}`, "_system");
  }

  mailTo(email) {
    window.open(`mailto:${email}`, "_system");
  }

  getLatestNav = () => {
    this.apiService.getData(Urls.getLatestNav).subscribe((response: any) => {
      this.latestNav = response.data ?  response.data.returnList : null;
    });
  };

  private setCarousel() {
    if (this.data.hasCarousel) {
      const pageContext = this.data.url;
      const source = window.innerWidth <= 768 ? "M" : "";
      switch (pageContext) {
        case "nfo":
          this.setNFOPageBanner(source);
          break;
        case "ceo-desk":
        case "ceo-desk-beta":
          this.setCEOPageBanner(source);
          break;
        case "iti-long-term-equity-fund":
          this.setLTEFPageBanner(source);
          break;
        default:
          this.setHomePageBanner(source);
      }
    }
  }

  private setHomePageBanner(source: string) {
    const obj = {
      source,
      bannerType: "Banners for Product",
    };
    this.apiService.postData(Urls.getBanners, obj).subscribe(
      response => {
        if(response.status === 0){
          this.banners = response.data.banners || [];
        }else{
          this.banners = [];
        }
        this.getLatestNav();
      },
      error=> {
        this.banners = [];
      }
    )
  }

  private setNFOPageBanner(source: string) {
    const obj = {
      source,
      bannerType: "Banners for NFO",
    };
    this.apiService.postData(Urls.getBanners, obj).subscribe(
      response => {
        if(response.status === 0){
          this.banners = response.data.banners || [];
        }else{
          this.banners = [];
        }
        this.getLatestNav();
      },
      error=> {
        this.banners = [];
      }
    )

  }

  private setCEOPageBanner(source: string) {
    const obj = {
      source,
      bannerType: "Banners for CEO",
    };
    this.apiService.postData(Urls.getBanners, obj).subscribe(
        response => {
          if(response.status === 0){
            this.banners = response.data.banners || [];
          }else{
            this.banners = [];
          }
          this.getLatestNav();
        },
        error => {
          this.banners = [];
        }
      )

  }

  private setLTEFPageBanner(source: string) {
    const obj = {
      source,
      bannerType: "Banners for LTEF",
    };
    this.apiService.postData(Urls.getBanners, obj).subscribe(
      response => {
        if(response.status === 0){
          this.banners = response.data.banners || [];
        }else{
          this.banners = [];
        }
        this.getLatestNav();
      },
      error=> {
        this.banners = [];
      }
    )
   
  }

  openNav = () => {
    if (window.innerWidth < 760) {
      this.modalService.open(NavMenuComponent, {
        windowClass: "align-modal-menu-mobile",
      });
    } else {
      this.modalService.open(NavMenuComponent, {
        windowClass: "align-modal-menu",
      });
    }
  };

  openPopUp = (val) => {
    if (val === "callback") {
      this.modalService.open(CallBackComponent, {
        size: "lg",
        windowClass: "align-modal-center",
      });
    } else if (val === "write") {
      this.modalService.open(WriteUsComponent, {
        size: "lg",
        windowClass: "align-modal-center",
      });
    } else {
      this.modalService.open(LocateUsComponent, {
        size: "lg",
        windowClass: "align-modal-center",
      });
    }
  };

  openPopUpMobile = (val) => {
    const width = window.innerWidth;
    if (width <= 768) {
      this.navFooterLink(val);
    } else {
      if (val === "call-back") {
        this.modalService.open(CallBackComponent, {
          size: "lg",
          windowClass: "align-modal-center",
        });
      } else if (val === "write-to-us") {
        this.modalService.open(WriteUsComponent, {
          size: "lg",
          windowClass: "align-modal-center",
        });
      } else if (val === "locate-us") {
        this.modalService.open(LocateUsComponent, {
          size: "lg",
          windowClass: "align-modal-center",
        });
      } else {
        this.navFooterLink(val);
      }
    }
  };

  navFooterLink = (link) => {
    this.router.navigate([link]);
  };


  investOnline = () => {
    if(!environment.isDRBuild){
      window.open("https://investonline.itiamc.com/", "_blank");
    }else{
      window.open("https://drinvestor.itiamc.com/", "_blank"); //DR-inv
    }
  };

  navPage = (url, val) => {
    this.router.navigate([url]);
    this.activeTab = val;
  };

  navFromBreadCrumb = (url) => {
    this.router.navigate([url]);
  };

  homeNav = () => {
    this.router.navigate(["/"]);
    this.scrollTop();
  };

  public viewDetails(banner:any){
    if(banner.schemeName){
      const url = banner.schemeName.replace(/\s/g, "-");
      this.router.navigateByUrl("products/" + url.toLowerCase());
    }else if(banner.clickableUrl && banner.clickableUrl.length >0 && banner.clickableUrl!=='null'){

      const isRelativePath = banner.clickableUrl.indexOf('http')===-1;
      isRelativePath ? this.router.navigateByUrl(banner.clickableUrl) :  window.open(banner.clickableUrl, "_blank");
    
    }
  }
}
